<template>
  <div
    style="
      overflow: hidden;
      height: 100%;
      padding: 20px;
      border-top: 1px solid #f7f7f7;
    "
  >
    <div
      style="
        background-color: #f6f6f6;
        padding: 10px 40px;
        border-radius: 10px;
        color: rgba(0, 0, 0, 0.8);
      "
    >
      <ul style="display: flex; align-items: center; padding: 10px">
        <li style="flex: 1">
          <text style="color: #a2a2a2">发薪单号</text>：{{
            state.model?.salaryReocrd?.salary_record_order_id
          }}
        </li>
        <li style="flex: 1">
          <text style="color: #a2a2a2">发薪单名称</text>：{{
            state.model?.salaryReocrd?.salary_record_name || "-"
          }}
        </li>
        <li style="flex: 1; display: flex; align-items: center">
          <text style="color: #a2a2a2">扣缴义务人</text>：
          <div
            v-if="state.model?.salaryReocrd?.withholding_agent_name"
            :data-type="
              state.model?.salaryReocrd?.withholding_agent_type == 1
                ? '供'
                : '扣'
            "
            :style="{
              '--dynamic-color':
                state.model?.salaryReocrd?.withholding_agent_type == 1
                  ? '#1e90ff'
                  : '#ffa500',
            }"
            class="withholding-badge"
          >
            {{ state.model?.salaryReocrd?.withholding_agent_name }}
          </div>
          <text v-else>-</text>
        </li>
      </ul>
      <ul style="display: flex; align-items: center; padding: 10px">
        <li style="flex: 1">
          <text style="color: #a2a2a2">对应月份</text>：{{
            state.model?.salaryReocrd?.month
          }}
        </li>
        <li style="flex: 1">
          <text style="color: #a2a2a2">发放时间</text>：{{
            state.model?.salaryReocrd?.pay_time
          }}
        </li>
        <li style="flex: 1; display: flex; align-items: center">
          <text style="color: #a2a2a2">发放金额</text>：
          <c_money :value="state.model?.salaryReocrd?.money"></c_money>
        </li>
      </ul>
    </div>
    <div style="width: 100%; overflow-x: auto; padding-bottom: 5px">
      <el-descriptions
        style="margin-top: 20px"
        direction="vertical"
        :column="100"
        border
        class="employee-salaryrecord-detail-desc"
      >
        <el-descriptions-item
          v-for="item in state.model?.payrollEmployee?.templateSortFields"
          :key="item"
        >
          <template #label>
            <li style="text-align: left; white-space: nowrap">
              {{ item.name }}
            </li>
          </template>
          <li style="text-align: left; white-space: nowrap">
            {{ state.model?.payrollEmployee?.info[item.field] || "-" }}
          </li>
        </el-descriptions-item>
      </el-descriptions>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { employee_salaryrecord_detail } from "@/http/employee";

export default {
  props: {
    employee_id: Number,
    id: Number,
  },
  setup(props) {
    const state = reactive({
      model: {},
      activeName: "info",
    });
    onMounted(() => {
      employee_salaryrecord_detail({
        employee_id: props.employee_id,
        id: props.id,
      }).then((res) => {
        if (res.status == 200) state.model = res.data.data;
      });
    });
    return { state, props };
  },
};
</script>
<style lang="less">
.employee-salaryrecord-detail-desc {
  .el-descriptions__cell {
    text-align: right;
  }
}
</style>
